
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect, AppDateTimePicker, AppButton } from '@/components';
import { useTournamentLeaderboardEdit } from '@/modules/tournament/leaderboard/model/edit';
import { timeUnits } from '@/common/utils/helpers';
import { ROUTE_NAME_TOURNAMENT } from '@/modules/tournament/router';

export default defineComponent({
    name: ROUTE_NAME_TOURNAMENT.LEADERBOARD.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppSelect, AppDateTimePicker, AppButton },
    setup() {
        const { model, v$, fetch, actions } = useTournamentLeaderboardEdit();

        onMounted(() => {
            fetch();
        });

        return { v$, model, actions, timeUnits };
    }
});
